module.exports = __webpack_public_path__ + "static/media/YM15_1.393600d6.jpg";